import { createModal } from 'react-modal-es';

const customUIComponent = (title, children) => (children);

const configs = {
  customUI: customUIComponent
};

const modal = createModal(configs);
export const openModal = modal.openModal;
export const closeModal = modal.closeModal;
export const closeAllModal = modal.closeAllModal;
export const connectModal = modal.connectModal;



// WEBPACK FOOTER //
// ./src/components/Modal.js